import { useState } from "react";
import { CardGroupPackage } from "../../interfaces/ScrollableCardGroupType";
import styles from "./ScrollableCardGroup.module.css";
import useComponentsStore from "../../store/componentsStateStore";
import { getGeneralImage, generateStyleClasses } from "../../helpers/commonFunctions";
import { logOrderProductsClickAddCart } from "../../membership/logging/helpers/commonLoggingFunctions";

export default function ScrollableCardGroupType({
  data,
  setIsDisabled,
  isDisabled,
}: {
  data: CardGroupPackage;
  setIsDisabled: any;
  isDisabled: boolean;
}) {
  const cardData = data?.data;
  const label = cardData?.label;
  const savePill = cardData?.savePill;
  const addOns = cardData?.addons;
  const unitPrice = cardData?.unitPrice;
  const totalPrice = cardData.totalPrice;
  const strikeThroughPrice = cardData?.strikeThroughUnitPrice;
  const selectionButton = cardData?.selectionButton;
  const highlightLabel = cardData?.highlightLabel;
  const [isLoading, setIsLoading] = useState(false);
  const { continueDraft } = useComponentsStore();

  const onClickHandler = async () => {
    if (isLoading || isDisabled) return;
    try {
      setIsLoading(true);
      setIsDisabled(true);
      logOrderProductsClickAddCart();
      await continueDraft(selectionButton?.payload);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
      setIsDisabled(false);
    }
  };

  return (
    <div className={`vas-d-flex vas-flex-column`}>
      {savePill ? (
        <div
          className={`vas-rounded-3 vas-text-success vas-px-2 vas-fw-bold vas-mx-4 vas-text-center ${styles.widget_save_tag}`}
          style={{
            border: `1px solid ${savePill?.borderColor}`,
            backgroundColor: savePill?.backgroundColor,
          }}
        >
          <span className="vas-fs-7" style={{ color: savePill?.textColor }}>
            {savePill?.text ?? ""}
          </span>
        </div>
      ) : (
        <div className={styles.widget_save_tag_holder} />
      )}
      <div
        className={` vas-m-2 vas-p-2 vas-card vas-border-radius ${styles.card}`}
      >
        <div className="vas-d-flex vas-flex-column vas-align-items-start vas-justify-content-between vas-p-2 vas-m-1">
          <div>
            <span
              className={`vas-text vas-d-block vas-mt-1 ${generateStyleClasses(
                highlightLabel?.style
              )} ${styles.popular_holder}`}
              style={{ color: highlightLabel?.textColor }}
            >
              {highlightLabel?.text}
            </span>
            <p
              className="vas-fs-4 vas-fw-bold vas-m-0 vas-mb-2"
              style={{ color: label?.textColor }}
            >
              {label?.text ?? ""}
            </p>
          </div>
          <div className={styles.repost_info_holder}>
            <p className="vas vas-mb-0 vas-mt-1 ">
              {addOns?.icon && (
                <img
                  className="vas vas-mb-1 vas-mx-1"
                  src={getGeneralImage(addOns?.icon)}
                  width={16}
                  height={16}
                  alt={"addons_icon"}
                />
              )}
              <span
                className={`vas-fs-7 ${generateStyleClasses(addOns?.title?.style)}`}
                style={{ color: addOns?.title?.textColor }}
              >
                {addOns?.title?.text ?? ""}
              </span>
            </p>
            {addOns?.description?.text ? (
              <p
                className={`vas-m-0 ${generateStyleClasses(addOns?.description?.style)}`}
                style={{
                  color: addOns?.description?.textColor ?? "",
                  fontSize: "13px",
                }}
              >
                {addOns?.description?.text ?? ""}
              </p>
            ) : (
              <p className={`vas ${styles.description_holder}`}></p>
            )}
          </div>
          <div className="vas-mt-2">
            <span
              className={`vas-fs-6 vas-d-block vas-text-decoration-line-through ${styles.old_price_holder}`}
              style={{
                color: strikeThroughPrice?.textColor,
              }}
            >
              {strikeThroughPrice?.text ?? ""}
            </span>
            <span
              className="vas-fs-6 vas-d-block"
              style={{ color: unitPrice?.textColor }}
            >
              {unitPrice?.text ?? ""}
            </span>
            <span
              className={`vas-fs-5 vas-d-block ${generateStyleClasses(
                totalPrice?.style
              )}`}
              style={{ color: totalPrice?.textColor }}
            >
              {totalPrice?.text ?? ""}
            </span>
          </div>
          <button
            onClick={onClickHandler}
            className={`vas-btn vas-w-100 vas-my-1 vas-fw-bold vas-px-2 vas-fs-5 vas-mt-2 vas-fs-5 vas-border-radius ${
              isDisabled ? "notAllowedPointer" : "pointerCursor"
            }`}
            style={{
              color: selectionButton?.textColor,
              backgroundColor: selectionButton?.backgroundColor,
            }}
            disabled={isLoading || isDisabled}
          >
            {isLoading && (
              <i className="vas-mx-1 vas-spinner-border vas-spinner-border-sm vas-p-2" />
            )}
            {selectionButton?.text ?? ""}
          </button>
        </div>
      </div>
    </div>
  );
}
